/**
 * Flip Cards Prize Reveal
 * ----------------------------------------------------------------
 * All copy, colors, and behavior config are read from data-* attributes
 * on the section root, and prize data is read from a JSON script tag
 * inside it (see sections/pick-cards-game.liquid). This file contains
 * no hardcoded merchant-facing values, so it works unchanged for any
 * number of section instances on a page, including inside the theme
 * editor where sections can be added, removed, or re-rendered.
 */
(function () {
  "use strict";

  var SELECTOR_ROOT = "[data-pick-cards]";

  function initAll() {
    var roots = document.querySelectorAll(SELECTOR_ROOT);
    for (var i = 0; i < roots.length; i++) {
      initFlipCards(roots[i]);
    }
  }

  function initFlipCards(root) {
    if (!root || root.dataset.flipCardsBound) return;
    root.dataset.flipCardsBound = "true";

    var config = readConfig(root);
    var prizes = readPrizes(root);
    if (!prizes.length) return;

    var maxFlips = config.maxFlips;
    if (!maxFlips || maxFlips > prizes.length) maxFlips = prizes.length;

    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-flip-card]"));
    var button = root.querySelector("[data-flip-button]");
    var counterEl = root.querySelector("[data-flip-counter]");
    var sublineEl = root.querySelector("[data-flip-subline]");
    var congratsEl = root.querySelector("[data-flip-congrats]");
    var rarityEl = root.querySelector("[data-flip-rarity]");
    var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var state = {
      flipped: 0,
      prizeIndex: 0,
      complete: false,
      startFired: false,
      endFired: false,
      revealed: []
    };

    var storedResult = readStoredResult(config.storageKey);
    if (restoreCompletedState(cards, button, counterEl, sublineEl, congratsEl, rarityEl, config, storedResult)) {
      state.complete = true;
      state.revealed = storedResult.revealed;
      state.flipped = storedResult.count;
    }

    

    cards.forEach(function (card) {
      card.addEventListener("click", function () {
        handleFlip(card);
      });
      card.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleFlip(card);
        }
      });
    });

    if (button) {
      button.addEventListener("click", function () {
        if (state.complete) navigateToDestination(config, state.revealed);
      });
    }

    function handleFlip(card) {
      if (state.complete) {
        navigateToDestination(config, state.revealed);
        return;
      }
      if (card.classList.contains("is-flipped") || card.classList.contains("is-locked")) return;
      if (state.flipped >= maxFlips) return;

      if (!state.startFired) {
        state.startFired = true;
        emit("flip_game_start");
      }

      revealPrize(card, prizes[state.prizeIndex]);

      state.revealed.push({
        cardIndex: parseInt(card.dataset.cardIndex, 10),
        prize: prizes[state.prizeIndex]
      });

      state.flipped++;
      state.prizeIndex = (state.prizeIndex + 1) % prizes.length;

      if (counterEl) counterEl.textContent = state.flipped + "/" + maxFlips;

      if (state.flipped < maxFlips) {
        if (button) button.textContent = config.buttonTemplate.replace("[n]", maxFlips - state.flipped);
      } else {
        finish();
      }
    }

    function revealPrize(card, prize) {
      revealPrizeOnCard(card, prize);
    }
    function finish() {
      state.complete = true;

      cards.forEach(function (card) {
        if (!card.classList.contains("is-flipped")) card.classList.add("is-locked");
      });

      if (sublineEl) sublineEl.classList.add("is-hidden");

      if (congratsEl) {
        var total = prizes.slice(0, maxFlips).reduce(function (sum, prize) {
          var numeric = parseFloat(String(prize.value || "").replace(/[^0-9.]/g, ""));
          return sum + (isNaN(numeric) ? 0 : numeric);
        }, 0);

        if (total > 0 && config.totalTemplate) {
          congratsEl.textContent = config.totalTemplate.replace("[v]", "$" + total.toLocaleString());
        }
        congratsEl.classList.add("is-visible");
      }

      if (rarityEl) rarityEl.classList.add("is-visible");

      if (button) {
        button.classList.add("is-active");
        button.textContent = config.continueText;
      }

      persistResult(config.storageKey, state.revealed, maxFlips);

      if (config.confettiEnabled && !prefersReducedMotion) {
        launchConfetti(config.confettiColors);
      }

      if (!state.endFired) {
        state.endFired = true;
        emit("flip_game_complete");
      }
    }
  }

  function readConfig(root) {
    var dataset = root.dataset;
    return {
      maxFlips: parseInt(dataset.maxFlips, 10) || 0,
      destinationUrl: dataset.destinationUrl || "",
      redirectToCheckout: dataset.redirectToCheckout === "true",
      storageKey: dataset.storageKey || "flip_cards_won_gifts",
      buttonTemplate: dataset.buttonTemplate || "Flip [n] More Cards",
      continueText: dataset.continueText || "Continue",
      totalTemplate: dataset.totalTemplate || "",
      confettiEnabled: dataset.enableConfetti === "true",
      confettiColors: (dataset.confettiColors || "")
        .split(",")
        .map(function (color) {
          return color.trim();
        })
        .filter(Boolean)
    };
  }

  function readPrizes(root) {
    var script = root.querySelector("script[data-flip-prizes]");
    if (!script) return [];
    try {
      var parsed = JSON.parse(script.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function navigateToDestination(config, revealed) {
    if (config.redirectToCheckout) {
        addPrizesToCartAndRedirect(revealed);
        return;
    }
    if (config.destinationUrl) {
        window.location.href = config.destinationUrl;
    }
  }

  function addPrizesToCartAndRedirect(revealed) {
    var items = (revealed || [])
        .filter(function (entry) { return entry.prize && entry.prize.variantId; })
        .map(function (entry) { return { id: entry.prize.variantId, quantity: 1 }; });

    if (!items.length) {
        window.location.href = "/checkout";
        return;
    }

    fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items })
    })
        .then(function () { window.location.href = "/checkout"; })
        .catch(function () { window.location.href = "/checkout"; });
  }


  function persistResult(storageKey, revealed, count) {
    try {
      window.localStorage.setItem(
        storageKey,
        JSON.stringify({
          revealed: revealed,
          count: count,
          at: Date.now()
        })
      );
    } catch (error) {
      /* localStorage unavailable (private mode, etc.) - fail silently */
    }
  }

  function revealPrizeOnCard(card, prize) {
    var imgWrap = card.querySelector("[data-flip-prize-img]");
    var nameEl = card.querySelector("[data-flip-prize-name]");
    var valueEl = card.querySelector("[data-flip-prize-value]");

    if (imgWrap) {
      imgWrap.innerHTML = prize.image ? '<img src="' + escapeAttribute(prize.image) + '" alt="">' : "";
    }
    if (nameEl) {
      nameEl.textContent = prize.name || "";
    }
    if (valueEl) {
      if (prize.value) {
        valueEl.innerHTML = "<span class='gift_free_text'>Free</span> <s>" + escapeHtml(prize.value) + "</s>";
        valueEl.style.display = "";
        valueEl.classList.toggle("pick-cards__prize-value--plain", !!prize.hideFreeText);
      } else {
        valueEl.innerHTML = "";
        valueEl.style.display = "none";
        valueEl.classList.remove("pick-cards__prize-value--plain");
      }
    }

    card.classList.add("is-flipped");
    card.setAttribute("aria-label", "Card revealed: " + (prize.name || ""));
  }

  function readStoredResult(storageKey) {
    try {
      var raw = window.localStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function restoreCompletedState(cards, button, counterEl, sublineEl, congratsEl, rarityEl, config, storedResult) {
    if (!storedResult || !Array.isArray(storedResult.revealed) || !storedResult.revealed.length) {
      return false;
    }

    storedResult.revealed.forEach(function (entry) {
      var card = cards.filter(function (c) {
        return parseInt(c.dataset.cardIndex, 10) === entry.cardIndex;
      })[0];
      if (card && entry.prize) revealPrizeOnCard(card, entry.prize);
    });

    cards.forEach(function (card) {
      if (!card.classList.contains("is-flipped")) card.classList.add("is-locked");
    });

    if (sublineEl) sublineEl.classList.add("is-hidden");

    if (congratsEl) {
      var total = storedResult.revealed.reduce(function (sum, entry) {
        var numeric = parseFloat(String((entry.prize && entry.prize.value) || "").replace(/[^0-9.]/g, ""));
        return sum + (isNaN(numeric) ? 0 : numeric);
      }, 0);
      if (total > 0 && config.totalTemplate) {
        congratsEl.textContent = config.totalTemplate.replace("[v]", "$" + total.toLocaleString());
      }
      congratsEl.classList.add("is-visible");
    }

    if (rarityEl) rarityEl.classList.add("is-visible");

    if (counterEl) counterEl.textContent = storedResult.count + "/" + storedResult.count;

    if (button) {
      button.classList.add("is-active");
      button.textContent = config.continueText;
    }

    return true;
  }

  function emit(eventName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName });
    window.dispatchEvent(new CustomEvent(eventName));
  }

  function launchConfetti(colors) {
    if (!colors.length) return;
    var pieceCount = 120;

    for (var i = 0; i < pieceCount; i++) {
      (function (index) {
        var piece = document.createElement("div");
        piece.className = "pick-cards-confetti-piece";
        piece.style.left = Math.random() * 100 + "vw";
        piece.style.background = colors[index % colors.length];
        piece.style.animationDuration = 2.4 + Math.random() * 1.8 + "s";
        piece.style.animationDelay = Math.random() * 0.6 + "s";
        piece.style.display = 'block';
        document.body.appendChild(piece);
        setTimeout(function () {
          piece.remove();
        }, 5200);
      })(i);
    }
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return (
        {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        }[char] || char
      );
    });
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, "&#96;");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify's theme editor swaps section markup in place.
  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector(SELECTOR_ROOT);
    if (root) initFlipCards(root);
  });
})();